import {
  CommissionSummary,
  CommissionSummaryResponse,
} from "../Services/SalesforceApi";

export const currentCommissionDate = () => {
  const dtTime = new Date(
    new Date().toLocaleString("en-US", {
      timeZone: "America/Denver",
    })
  );

  if (
    dtTime.getDate() <= 1 &&
    dtTime.getHours() <= 1 &&
    dtTime.getMinutes() < 5
  ) {
    dtTime.setHours(-1);
  }

  return dtTime;
};

export const scheduledLrpFromCommissionDate = (
  scheduledLrp: number,
  scheduledDate: Date | string
) => {
  const date = new Date(scheduledDate);
  const commissionDate = currentCommissionDate();

  if (date < commissionDate) {
    return 0;
  }

  return scheduledLrp;
};

export const transformCommissionSummaries = (
  data: CommissionSummaryResponse
) => {
  return data.map(transformCommissionSummary);
};

export const transformCommissionSummary = (data: CommissionSummary) => {
  const nextLRPRunDate = standardiseLRPRunDate(data.nextLRPRunDate);

  return {
    ...data,
    nextLRPRunDate,
    scheduledLrpPv: scheduledLrpFromCommissionDate(
      data.scheduledLrpPv,
      nextLRPRunDate
    ),
  };
};

// The API can return a date in the format of "2022-01-01" or "20220101"
// It should return it in "2024-10-06" format
const standardiseLRPRunDate = (date: string | null | undefined): string => {
  if (date && date.length === 8) {
    return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
  }

  if (date && date.length === 10) {
    return date;
  }

  return "0";
};
